export const Types = {
  GET_REQUEST: "banners/GET_REQUEST",
  GET_SUCCESS: "banners/GET_SUCCESS",
  GET_FAILURE: "banners/GET_FAILURE",
  GET_HIGHLIGHTS_REQUEST: "banners/GET_HIGHLIGHTS_REQUEST",
  GET_HIGHLIGHTS_SUCCESS: "banners/GET_HIGHLIGHTS_SUCCESS",
  GET_HIGHLIGHTS_FAILURE: "banners/GET_HIGHLIGHTS_FAILURE",
  GET_BANNER_PRODUCTS_REQUEST: "banners/GET_BANNER_PRODUTOS_REQUEST",
  GET_BANNER_PRODUCTS_SUCCESS: "banners/GET_BANNER_PRODUCTS_SUCCESS"
};

const INITIAL_STATE = {
  data: [],
  highlights: [],
  bannerProducts: [],
  loading: true,
  highlightsLoading: false,
  highlightsError: null,
  error: null,
  loaderSize: 25,
  windowSize: 480
};

export default function banners(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      return { ...state, data: action.payload.data, loading: false, error: null };
    case Types.GET_FAILURE:
      return { ...state, data: [], loading: false, error: action.payload.message };
    case Types.GET_HIGHLIGHTS_REQUEST:
      return { ...state, highlightsLoading: true, highlightsError: null };
    case Types.GET_HIGHLIGHTS_SUCCESS:
      return {
        ...state,
        highlights: action.payload.data,
        highlightsLoading: false,
        highlightsError: null
      };
    case Types.GET_HIGHLIGHTS_FAILURE:
      return {
        ...state,
        highlights: [],
        highlightsLoading: false,
        highlightsError: action.payload.message
      };
    case Types.GET_BANNER_PRODUCTS_REQUEST:
      return { ...state, loading: true };
    case Types.GET_BANNER_PRODUCTS_SUCCESS:
      return { ...state, bannerProducts: action.payload.data, loading: false };
    default:
      return state;
  }
}

export const Creators = {
  getBannersRequest: () => ({
    type: Types.GET_REQUEST
  }),

  getBannersSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data }
  }),

  getBannersFailure: message => ({
    type: Types.GET_FAILURE,
    payload: { message }
  }),

  getHighlightsRequest: () => ({
    type: Types.GET_HIGHLIGHTS_REQUEST
  }),

  getHighlightsSuccess: data => ({
    type: Types.GET_HIGHLIGHTS_SUCCESS,
    payload: { data }
  }),

  getHighlightsFailure: message => ({
    type: Types.GET_HIGHLIGHTS_FAILURE,
    payload: { message }
  }),

  getBannersProductsRequest: uuid => ({
    type: Types.GET_BANNER_PRODUCTS_REQUEST,
    payload: { uuid }
  }),

  getBannersProductsSuccess: data => ({
    type: Types.GET_BANNER_PRODUCTS_SUCCESS,
    payload: { data }
  })
};
